import { ReactNode } from 'react';

import { fontStyles } from '@/styles/typography';

import { CheckmarkIcon } from '@/ui/Icons/CheckmarkIcon';

export const StyledH2 = ({ className, children }: { className?: string; children: ReactNode }) => (
  <h2 className={fontStyles({ variant: 'H2', class: ['mb-4', 'grid', className] })}>{children}</h2>
);

export const StyledParagraph = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <p className={fontStyles({ variant: 'BODY_LG', class: ['text-token-gray-800', className] })}>
    {children}
  </p>
);

export const StyledPrimaryCell = ({
  className,
  children,
  style,
}: {
  className?: string;
  children: ReactNode;
  style?: React.CSSProperties;
}) => (
  <section
    className={`border border-token-gray-200 overflow-hidden rounded-md w-full mx-auto mb-5 bg-token-gray-100 flex justify-center max-w-[1240px] ${className}`}
    style={style}
  >
    {children}
  </section>
);

export const CheckMarkList = ({ items }: { items: string[] }) => (
  <ul className="text-token-gray-800 mt-1">
    {items.map((text) => (
      <li className="items-center flex mt-4 first:mt-0" key={text}>
        <div className="items-center self-start rounded-[50%] text-primitive-basic-white flex h-6 justify-center w-6 shrink-0 shadow-[0px_1px_3px_rgba(0,0,0,0.12),inset_0px_-1px_0px_rgba(0,0,0,0.16)] bg-[linear-gradient(308.48deg,_#02A863_-13.93%,_rgba(2,168,99,0.49)_112.7%)]">
          <CheckmarkIcon />
        </div>
        <span
          className={fontStyles({
            variant: 'BODY_LG',
            class: ['ml-3', 'text-token-gray-800', 'font-normal'],
          })}
        >
          {text}
        </span>
      </li>
    ))}
  </ul>
);
